import React from 'react';

import { EPresence } from 'src/api/users-api';

const ONLINE_COLOR = '#10b981';
const OFFLINE_COLOR = '#b8b5ad';

type Props = {
    /** Anything other than EPresence.ONLINE (including undefined) renders the gray "away" dot. */
    presence?: EPresence;
    size?: number;
    /** Adds a white ring so the dot reads clearly when overlaid on an avatar. */
    withBorder?: boolean;
};

/**
 * A small online/away presence indicator dot, shared across the team sidebar,
 * profile menu, and conversation owner column so the colors stay consistent.
 */
export const PresenceDot: React.FC<Props> = ({ presence, size = 8, withBorder = false }) => {
    const isOnline = presence === EPresence.ONLINE;
    return (
        <span
            aria-hidden
            data-testid="presence-dot"
            data-presence={isOnline ? 'online' : 'away'}
            style={{
                display: 'inline-block',
                width: size,
                height: size,
                borderRadius: '50%',
                backgroundColor: isOnline ? ONLINE_COLOR : OFFLINE_COLOR,
                border: withBorder ? '2px solid #fff' : undefined,
                boxSizing: 'content-box',
                flexShrink: 0,
            }}
        />
    );
};

export default PresenceDot;
